import { SelectOption, SelectOptionsOrGroups } from '../types';
import { isTruthy } from '@ardoq/common-helpers';
import { selectOptionOperations } from '../selectOptionsOperations';
import { isNull } from 'lodash';

export const findOption = <TValue,>(
  value?: TValue | SelectOption<TValue> | null,
  options: SelectOption<TValue>[] = [],
  isCreatable = false,
  isControlled = false,
  allowNullOptionValue = false
): SelectOption<TValue> | undefined => {
  const valueIsNotAtomic = !['string', 'number'].includes(typeof value);
  if (
    isControlled &&
    valueIsNotAtomic &&
    !value &&
    !(allowNullOptionValue && isNull(value))
  ) {
    return undefined;
  }
  const isValueASelectOption = valueIsNotAtomic && value !== null;
  // @ts-expect-error Needs love
  if (isValueASelectOption) return value;
  const foundOption = options.find(option => option.value === value);
  if (foundOption) return foundOption;
  if (isCreatable && value)
    // @ts-expect-error Needs love
    return isValueASelectOption ? value : { label: value, value };
  return undefined;
};

export const findOptions = <TValue,>(
  values: (TValue | SelectOption<TValue>)[] = [],
  options: SelectOptionsOrGroups<TValue> = [],
  isCreatable = false
) => {
  const flatOptions =
    selectOptionOperations.optionsOrGroupsToFlatOptions(options);
  return values
    .map(value => findOption(value, flatOptions, isCreatable))
    .filter(isTruthy);
};

export function arrayWithItems<T>(array: T[]) {
  return array.length ? array : undefined;
}

export const stringToOption = (value: string) => ({
  label: value,
  value: value,
});
